module.exports = __webpack_public_path__ + "resources/img/zoom_lowlight_mode.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_lowlight_mode.png
// module id = 1373
// module chunks = 0